import { ReactComponent as Pause } from 'approot/shared/icons/icon_pause.svg';
import Icon, { IconProps } from './icon';

const IconPause = (props: IconProps) => {
  return <Icon {...props} Svg={Pause} />;
};

export default IconPause;
